import { gql } from '@apollo/client'
import { USER_FRAGMENT } from './UserFragment'

export const DISPLAY_TRANSACTION_FRAGMENT = gql`
  fragment DisplayTransaction on DisplayTransaction {
    displayId
    upc
    brand
    periodStartDate
    periodEndDate
    quantity
    employee {
      ...User
    }
  }
  ${USER_FRAGMENT}
`
